/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

export const BUCHUNGSSTATUS_WERT: { [k in Buchungsstatus]: number } = Object.freeze({
    ANFRAGE: 1,
    RESERVIERUNG: 2,
    BUCHUNG: 3,
    ABGELEHNT: 4
});

enum Buchungsstatus {
    "ANFRAGE" = "ANFRAGE",
    "RESERVIERUNG" = "RESERVIERUNG",
    "BUCHUNG" = "BUCHUNG",
    "ABGELEHNT" = "ABGELEHNT"
}

export default Buchungsstatus;

export type BuchungsstatusType = typeof Buchungsstatus[keyof typeof Buchungsstatus];
